export const MAX_AMENITY_DEPOSIT_AMOUNT = 1000;
export const MAX_AMENITY_TOTAL_FEE_AMOUNT = 5000;
